import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import TeethSvgModelV2Pim from './TeethSvgModelV2Pim';
import { FindElment, overlappingArrayElements, toggleArrayOverLab, withZeroNum } from 'lib/library';
import { setBasicTeeth, setMergeSortTeethElement, setTeethElement } from 'lib/teeth/teethCompiler';
import { NOTATION_CONFIG } from 'lib/teeth/teethMapper';
import { useDidUpdateEffect } from 'lib/utils';
import _ from 'lodash';
import { color, disableDrag } from 'styles/utils';
// fake data
import { teeth_v2_bg, teeth_v2_bg_thumbnail } from 'components/base/images';
import { enableMapSet } from 'immer';
import { toothInitValue } from 'lib/teeth/teethMapper';
import { useTranslation } from 'react-i18next';
import { AppActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { useImmer } from 'use-immer';
import { ITooth } from 'lib/types/clinic/projectTypes';
enableMapSet();

// const svgConfig = {
//   xmlns: 'http://www.w3.org/2000/svg',
//   width: '100%',
//   height: '100%',
//   // xmlSpace: 'preserve',
//   // version: '1.1',
//   // viewBox: '0 0 641 1145',
//   viewBox: '0 -10 641 1145',
//   id: 'teethSvg',
// };

const svgConfig = {
  xmlns: 'http://www.w3.org/2000/svg',
  x: '0',
  y: '0',
  enableBackground: 'new 0 0 480.91 862.17',
  version: '1.1',
  viewBox: '0 0 480.91 862.17',
  xmlSpace: 'preserve',
};

const classNaming = {
  tooth: {
    active: 'tooth-active',
  },
};
const findElement = new FindElment();

const TeethSvgState = {
  infoToothList: [],
  keyCombine: {
    keyList: new Set(),
    ctrl: false,
    shift: false,
  },
};

function TeethSvg(props: any) {
  let {
    onClick = () => {},
    onChange = () => {},
    // temp
    isEdit = false,
    numbering = null,
    tooth = { value: { ...toothInitValue }, setValue: () => {} },
    // indication = {},
    teeth = { value: [], setValue: () => {} },
    teethContextActions = { value: {}, setValue: () => {} },
    indicationSeq = { value: '', setValue: () => {}, onChange: () => {} },
    copyData = { value: null, setValue: () => {} },
    // copiedData = {},
    hiddenToothText = false,
    onToggleTooth = () => {},
    onChangeToothValue = () => {},
  } = props;
  const { t } = useTranslation();
  const { indicationInfo } = useShallowAppSelector(state => ({
    indicationInfo: state.util.indicationInfo.data?.indicationInfo,
  }));
  const partList = indicationInfo?.partList || [];
  const [values, setValues] = useImmer(TeethSvgState);
  const svgRef = useRef<any>(null);

  numbering = numbering?.value || null;
  // legacy code 호환
  const teethProps = teeth?.value || [];

  // nubmering.value 변경
  const hasTeethIndexList = teethProps?.map((item: any) => String(item?.number));
  //
  const selectedConf = {
    number: tooth?.value?.number,
    type: 'teeth',
    list: [],
  };

  const hasCopiedData = !!copyData?.value?.number;
  const hasSelectedData = !!tooth?.value?.hasData;
  const isSelected = !!tooth?.value?.number;
  const keyCombineList = values.keyCombine.keyList;
  const hasBackspaceKey = keyCombineList.has('BACKSPACE');
  const hasDeleteKey = keyCombineList.has('DELETE');
  const hasShiftKey = keyCombineList.has('SHIFT');
  const hasCtrlKey = keyCombineList.has('CONTROL');
  const hasCKey = keyCombineList.has('C');
  const hasVkey = keyCombineList.has('V');
  const isCopyKeyCombine = hasCtrlKey && hasCKey;
  const isPasteKeyCombine = hasCtrlKey && hasVkey;

  useEffect(() => {
    console.log('PIM] TeethSvg teeth PIM________ ', teeth);
  }, [teeth]);

  // 최초 svgRef init
  // NOTE: svg bind 됬을떄 text들어있는 태그들 가져와서 재소팅 후 infoToothList 값 넣음
  useEffect(() => {
    if (!!svgRef.current) {
      const convertFormat = {
        elements: Array.from(svgRef.current?.querySelectorAll('text')),
      };
      // teeth init
      const setTeethFormat = {
        list: setMergeSortTeethElement(convertFormat),
        defaultValue: teethProps,
      };

      setValues((draft: any) => {
        draft.infoToothList = setBasicTeeth(setTeethFormat);
      });
    }
  }, [!!svgRef.current, isEdit]);

  // create, update  teeth
  useEffect(() => {
    // teeth
    const setTeethFormat = {
      teeth: teethProps,
      list: values.infoToothList,
    };
    console.log('HDS1] setTeethFormat ______ ', setTeethFormat);
    setTeethElement(setTeethFormat);

    svgRef.current.focus();
  }, [!!svgRef.current, teethProps, teeth?.value, isEdit]);

  // numbering change
  useEffect(() => {
    const numberingFormat = {
      mergeToothList: values.infoToothList,
      numbering,
    };
    setNumberingElement(numberingFormat);
  }, [values.infoToothList, numbering, isEdit]);

  // selected useEffect, outline color
  useEffect(() => {
    if (isEdit) {
      values.infoToothList.map((item: any) => {
        if (item.number === tooth?.value?.number) {
          item.groupElement.classList.add(classNaming.tooth.active);
        } else {
          item.groupElement.classList.remove(classNaming.tooth.active);
        }
      });
    }
  }, [values.infoToothList, tooth?.value, isEdit]);

  const keyDownEventFn = (e: any) => {
    const key = e.key;
    if (!values.keyCombine.keyList.has(key.toUpperCase())) {
      setValues(draft => {
        draft.keyCombine.keyList.add(key.toUpperCase());
      });
    }
  };
  const keyUpEventFn = (e: any) => {
    const key = e.key;
    if (!!key && values.keyCombine.keyList.has(key.toUpperCase())) {
      setValues(draft => {
        draft.keyCombine.keyList.delete(key.toUpperCase());
      });
    }
  };

  const handleClickTeethSvg = (config: any) => {
    const isRightClick = config.type === 'contextmenu';
    if (!isRightClick) {
      onToggleTooth(config.tooth.number);
      let selectedFormat = {
        ...config.tooth,
        number: config.tooth.number,
        hasData: true,
        hasPim: true,
        // hasData: config.tooth?.hasData,
      };

      // if (!!tooth.setValue) {
      //   console.log('PIM] [[[[[[ 5555555555 ]]]]]] ___ ', selectedFormat);

      //   tooth.setValue(selectedFormat);
      // }
      // if (!!teeth.setValue) {
      //   console.log('PIM] [[[[[[ 66666666666 ]]]]]]');

      //   console.log('PIM] teeth.setValue !!!!! __________', selectedFormat);
      //   teeth.setValue((draft: any) =>
      //     overlappingArrayElements({ list: draft, value: selectedFormat, condition: 'number' }),
      //   );
      // }
    } else {
      teeth.setValue((draft: any) => draft.filter((i: any) => i.number !== config.tooth.number));
      const emptyData = { number: null, hasData: false, hasPim: true };
      tooth.setValue(emptyData);
    }
  };

  const copyFailPopup = useCallback(() => {
    AppActions.add_popup({
      isOpen: true,
      title: t('MODAL_FAIL_COPY_TITLE'),
      content: t('MODAL_FAIL_COPY_CONTENT'),
      isTitleDefault: true,
      isContentDefault: true,
    });
  }, []);
  const pasteFailPopup = useCallback(() => {
    AppActions.add_popup({
      isOpen: true,
      title: t('MODAL_FAIL_PASTE_TITLE'),
      content: t('MODAL_FAIL_PASTE_CONTENT'),
      isTitleDefault: true,
      isContentDefault: true,
    });
  }, []);

  const handleClick = (config: any) => {
    const { e, type } = config;
    const target = e.target;
    const parentTarget = target.parentElement;
    let targetElement = target;
    let isToothClick = null;
    const parentTargetAttrArray = Array.from(parentTarget.attributes).map(
      (item: any) => `${item?.name}-${item?.value}`,
    );
    const targetAttrArray = Array.from(target.attributes).map(
      (item: any) => `${item?.name}-${item?.value}`,
    );
    const comparisonArray = [...parentTargetAttrArray, ...targetAttrArray];
    if (comparisonArray.some(item => item === 'data-name-tooth-g')) {
      targetElement = parentTarget;
      isToothClick = true;
    }
    const isRightClick = e.type === 'contextmenu';

    // NOTE: tooth
    if (isToothClick) {
      const getToothDataTooth = targetElement.getAttribute('data-tooth-id');
      const getToothValue = Number(getToothDataTooth?.replace(/\D/g, ''));
      const getToothIndex = Number(targetElement.getAttribute('data-tooth-index'));

      if (!isEdit) {
        handleClickTeethSvg({ tooth: { number: getToothValue } });
        return;
      }

      if (isRightClick) {
        const currentToothData = teethProps.find((item: any) => item.number === getToothValue);

        handleClickTeethSvg({
          tooth: {
            ...currentToothData,
            number: getToothValue,
            hasData: !!currentToothData,
            hasPim: true,
          },
          type: 'contextmenu',
        });
        return;
      }

      if (hasShiftKey) {
        console.log('shift 누르고 치아 클릭');
        const currentCopyData = tooth.value;
        if (tooth.value.number === getToothValue)
          return console.log('shift 누르고 같은 치아 클릭 ');

        if (!currentCopyData?.number || !currentCopyData?.hasPim) {
          setValues(draft => {
            draft.keyCombine.keyList = new Set([]);
          });

          if (!currentCopyData?.hasPim || !currentCopyData?.number) {
            pasteFailPopup();
            return console.log('카피된 데이터 없음');
          }
        }

        // 잡은 치아 기준으로 셀렉트
        let multiSelectedList: any = [];
        let errorType;
        const startNumber = NOTATION_CONFIG.fdi.list.indexOf(+tooth.value.number);
        const endNumber = +getToothIndex;
        const dirention = endNumber - startNumber > 0 ? 'front' : 'back';

        let toothRange = '';
        // 상악 범위  0~15, 하악 범위16 ~31
        if (startNumber <= 15 && endNumber > 15) {
          errorType = 'errorTopTeethRange'; // return console.log('현재 치아에서는 상악 범위내에서만 선택 가능');
          toothRange = t('GLOBAL_MAXILLA');
          AppActions.add_popup({
            isOpen: true,
            title: t('MODAL_FAIL_TOOTH_RANGE_COPY_TITLE', { toothRange }),
            content: t('MODAL_FAIL_TOOTH_RANGE_COPY_CONTENT', { toothRange }),
            isTitleDefault: true,
            isContentDefault: true,
          });
          return;
        } else if (startNumber >= 16 && endNumber < 16) {
          errorType = 'errorBottomTeethRange'; // return console.log('현재 치아에서는 하악 범위내에서만 선택 가능');
          toothRange = t('GLOBAL_MANDIBLE');
          AppActions.add_popup({
            isOpen: true,
            title: t('MODAL_FAIL_TOOTH_RANGE_COPY_TITLE', { toothRange }),
            content: t('MODAL_FAIL_TOOTH_RANGE_COPY_CONTENT', { toothRange }),
            isTitleDefault: true,
            isContentDefault: true,
          });
          return;
        } else {
          if (dirention === 'front') {
            for (let i = startNumber; i <= endNumber; i++) {
              multiSelectedList.push({
                ...currentCopyData,
                number: NOTATION_CONFIG.fdi.list[i],
                type: 'tooth',
              });
            }
          } else if (dirention === 'back') {
            for (let i = startNumber; i >= endNumber; i--) {
              multiSelectedList.push({
                ...currentCopyData,
                number: NOTATION_CONFIG.fdi.list[i],
                type: 'tooth',
              });
            }
          }
        }
        teeth.setValue((draft: any) =>
          overlappingArrayElements({
            list: draft,
            value: multiSelectedList,
            condition: 'number',
          }),
        );
        tooth.setValue((draft: any) => ({ ...draft, number: getToothValue }));
      } else if (hasCtrlKey) {
        // 치아를 선택 후 ctrl누른 상태에서 다른 치아에 복사하는 기능
        console.log('ctrl 누르고 치아 클릭');
        const currentCopyData = tooth.value;
        // 선택된 치아 또는 카피된 데이터 없음
        if (tooth.value.number === getToothValue) return console.log('ctrl 누르고 같은 치아 클릭 ');

        if (!currentCopyData?.number || !currentCopyData?.hasData) {
          setValues(draft => {
            draft.keyCombine.keyList = new Set([]);
          });
          if (!currentCopyData?.hasData || !currentCopyData?.number) {
            pasteFailPopup();
            return console.log('카피된 데이터 없음');
          }
        }

        const pasteToothData = {
          ...currentCopyData,
          number: getToothValue,
        };
        teeth.setValue((draft: any) =>
          overlappingArrayElements({ list: draft, value: pasteToothData, condition: 'number' }),
        );
        tooth.setValue((draft: any) => ({ ...draft, number: getToothValue }));
      } else {
        console.log('normal click');
        // 그냥 tooth click
        const currentToothData = teethProps.find((item: any) => item.number === getToothValue);
        handleClickTeethSvg({
          tooth: {
            ...currentToothData,
            number: getToothValue,
            hasData: !!currentToothData,
            hasPim: true,
          },
        });
      }
    }

    // 치아 클릭 하지 않았을 경우 초기화
    // ContextMenu active 초기화
    if (!isToothClick) {
      console.log('!isToothClick');
    }
  };

  // NOTE: keyboard event
  const handleCombineKey = () => {
    if (!isEdit) return;
    const keyCombineDelete = hasDeleteKey || hasBackspaceKey;

    //NOTE: copy
    if (isCopyKeyCombine) {
      console.log('copy : ctrl + c');
      if (!isSelected) {
        console.log('선택 된 데이터가 없습니다.');
      } else if (isSelected && !hasSelectedData) {
        console.log('선택 됐으나 데이터가 없습니다.');
        copyFailPopup();
      } else {
        const currentToothData = teeth.value.find((i: any) => i.number === tooth.value.number);
        copyData.setValue({ ...currentToothData, hasData: true });
        teethContextActions.setValue((draft: any) => {
          draft.paste.active = true;
        });
      }
    } else if (isPasteKeyCombine) {
      console.log('paste : ctrl + v');
      // NOTE: paste
      if (!isSelected) {
        console.log('선택 된 치아가 없습니다.');
      } else if (isSelected && !hasCopiedData) {
        console.log('선택 됐으나 데이터가 없습니다.');
        pasteFailPopup();
      } else {
        // 카피된 데이터가 있을때
        const pasteToothData = {
          ...copyData.value,
          number: tooth.value.number,
        };
        teeth.setValue((draft: any) =>
          overlappingArrayElements({ list: draft, value: pasteToothData, condition: 'number' }),
        );
        onChangeToothValue(pasteToothData);
      }
    } else if (keyCombineDelete) {
      // NOTE: delete
      console.log('delete');
      if (!isSelected) {
        console.log('선택 된 데이타가 없습니다.');
      } else if (isSelected && !hasSelectedData) {
        console.log('선택 됐으나 데이터가 없습니다.');
      } else {
        teeth.setValue((draft: any) => draft.filter((i: any) => i.number !== tooth.value.number));
        const emptyData = { number: null, hasData: false, hasPim: true };
        tooth.setValue(emptyData);
        if (tooth.value.number === copyData.value.number) {
          copyData.setValue(emptyData);
          teethContextActions.setValue((draft: any) => {
            draft.paste.active = false;
          });
        }
        teethContextActions.setValue((draft: any) => {
          draft.copy.active = false;
          draft.delete.active = false;
        });
      }
    }
  };

  // NOTE: keyboard event
  useEffect(() => {
    if (!isEdit) return;

    handleCombineKey();

    window.addEventListener('keydown', keyDownEventFn);
    window.addEventListener('keyup', keyUpEventFn);

    return () => {
      window.removeEventListener('keydown', keyDownEventFn);
      window.removeEventListener('keyup', keyUpEventFn);
    };
  }, [keyCombineList, isEdit]);

  // 색상 적용
  const swapLinearComponent = <SwapLinearGradient items={partList} />;

  return (
    <Styled.TeethSvg
      data-component-name="TeethSvg"
      className={`teethSvg`}
      hiddenToothText={hiddenToothText}
      teethBg={hiddenToothText ? teeth_v2_bg_thumbnail : teeth_v2_bg}
    >
      <svg
        {...svgConfig}
        ref={svgRef}
        onClick={e => handleClick({ type: 'svg', e })}
        onContextMenu={e => handleClick({ type: 'svg', e })}
      >
        <TeethSvgModelV2Pim swapLinearComponent={swapLinearComponent} />
      </svg>
    </Styled.TeethSvg>
  );
}

// make setting swap svg LinearGradient element
function SwapLinearGradient(props: any) {
  const { items = [] } = props;
  return (
    <>
      {items.map((item: any, idx: number) => (
        <linearGradient id={`swap-linear-${item.idx}`} key={idx}>
          <stop stopColor={item.color}></stop>
        </linearGradient>
      ))}
    </>
  );
}

// setting numbering element, numbering null check
function setNumberingElement(config: any = {}) {
  const { mergeToothList = [], numbering = null } = config;
  const findNotationList = _.find(NOTATION_CONFIG, item => {
    const indexInfo = numbering === null ? 0 : numbering;
    return item.index === indexInfo;
  })?.list;

  // numbering mapping
  mergeToothList.map((item: any, idx: number) => {
    if (item.element) {
      const changeNumber = !!findNotationList && findNotationList[idx];

      item.element.textContent = withZeroNum(changeNumber);
    }
  });
}

const Styled = {
  TeethSvg: styled.div<{ teethBg: any; hiddenToothText: any }>`
    position: relative;
    background: ${({ teethBg }) => `url(${teethBg}) no-repeat center / cover`};

    svg path,
    tspan,
    text {
      cursor: pointer;
    }
    .teethSvg__tooth {
      ${disableDrag}
      pointer-events: ${({ hiddenToothText }) => hiddenToothText && 'none'};
      &:hover {
      }
      &.tooth-active,
      &.tooth-fixed {
        path {
          stroke: ${color.blue};
          stroke-width: 1.5px;
        }
        & .teethSvg__text {
        }
      }
      &.hasData {
        path {
          fill-opacity: 0.5;
        }
        .teethSvg__text {
        }
      }
      .teethSvg__text {
        font-weight: 700;
        display: ${({ hiddenToothText }) => hiddenToothText && 'none'};
      }
    }

    width: 100%;
    &.isView {
      .teethSvg__tooth.tooth-active {
        stroke: blue;
        stroke-width: 0;
        & .teethSvg__text {
          stroke-width: 0.1;
        }
      }
    }
  `,
};

export default React.memo(TeethSvg);
